// components/whatsapp/WhatsAppStatusScreen.jsx
import React, { useState, useEffect } from 'react';
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { disconnectWhatsAppMeta } from '../../services/apiServices';

const WhatsAppStatusScreen = ({ partnerData, onEditRegistration }) => {
    const [currentStatus, setCurrentStatus] = useState(partnerData.status || 'pending');

    console.log(partnerData, 'partnerData');
    console.log(currentStatus, 'currentStatus');
    const [error, setError] = useState(null);
    // Calculate days until token expiry
    const getDaysUntilExpiry = () => {
        if (!partnerData.waba_access_token_expires_at) return null;

        const expiryDate = new Date(partnerData.waba_access_token_expires_at);
        const now = new Date();
        const diffTime = expiryDate - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return {
            days: diffDays,
            isExpiringSoon: diffDays <= 7,
            isExpired: diffDays <= 0
        };
    };

    const tokenExpiry = getDaysUntilExpiry();

    const getStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return (
                    <span className="badge bg-success">
                        <MDBIcon icon="check-circle" className="me-1" />
                        Active
                    </span>
                );
            case 'pending':
                return (
                    <span className="badge bg-warning">
                        <MDBIcon icon="clock" className="me-1" />
                        Pending
                    </span>
                );
            case 'inactive':
                return (
                    <span className="badge bg-danger">
                        <MDBIcon icon="times-circle" className="me-1" />
                        Inactive
                    </span>
                );
            default:
                return (
                    <span className="badge bg-secondary">
                        <MDBIcon icon="question-circle" className="me-1" />
                        {status || 'Unknown'}
                    </span>
                );
        }
    };

    const disconnectWhatsApp = async () => {
        try {
            const response = await disconnectWhatsAppMeta(partnerData.gymid);
            const data = await response.json();

            if (data.success) {
                // setIsConnected(false);
                // setAccountInfo(null);
                setError(null);
            } else {
                setError(data.message || 'Failed to disconnect');
            }
        } catch (err) {
            setError('Failed to disconnect.');
        }
    };

    const getPhoneQualityBadge = (rating) => {
        switch (rating) {
            case 'GREEN':
                return (
                    <span className="badge bg-success">
                        <MDBIcon icon="check-circle" className="me-1" />
                        High Quality
                    </span>
                );
            case 'YELLOW':
                return (
                    <span className="badge bg-warning">
                        <MDBIcon icon="exclamation-triangle" className="me-1" />
                        Medium Quality
                    </span>
                );
            case 'RED':
                return (
                    <span className="badge bg-danger">
                        <MDBIcon icon="times-circle" className="me-1" />
                        Low Quality
                    </span>
                );
            case 'UNKNOWN':
                return (
                    <span className="badge bg-secondary">
                        <MDBIcon icon="question-circle" className="me-1" />
                        Quality Unknown
                    </span>
                );
            default:
                return (
                    <span className="badge bg-secondary">
                        <MDBIcon icon="minus-circle" className="me-1" />
                        {rating || 'N/A'}
                    </span>
                );
        }
    };

    const getStatusMessage = (status) => {
        switch (status) {
            case 'active':
                return "Your WhatsApp Business account is active and ready to use!";
            case 'pending':
                return "Your registration is being processed...";
            case 'inactive':
                return "Your account is inactive. Please contact support.";
            default:
                return "Registration submitted.";
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    // Get token preview (masked)
    const getTokenPreview = (token) => {
        if (!token) return 'N/A';
        return `${token.substring(0, 15)}...${token.substring(token.length - 15)}`;
    };

    // Calculate time elapsed since creation
    const getTimeElapsed = () => {
        if (!partnerData.createdAt) return 'Just now';

        const createdAt = new Date(partnerData.createdAt);
        const now = new Date();
        const diffInSeconds = Math.floor((now - createdAt) / 1000);

        if (diffInSeconds < 60) {
            return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
        } else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
        } else {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days} day${days !== 1 ? 's' : ''} ago`;
        }
    };

    return (
        <div className="whatsapp-status-container">
            {/* Header */}
            <div className="whatsappbuss-header mb-4">
                <h2 className="whatsappbuss-title">
                    <MDBIcon fab icon="whatsapp" className="whatsappbuss-icon" />
                    WhatsApp Business Account
                </h2>
                <p className="whatsappbuss-subtitle">
                    Your WhatsApp Business integration details and status
                </p>
            </div>

            {/* Status Card */}
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <div>
                            <h4 className="card-title mb-1">
                                {partnerData.verified_name || partnerData.waba_name || 'WhatsApp Business Account'}
                            </h4>
                            <p className="text-muted mb-0">
                                <MDBIcon icon="phone" className="me-1" />
                                {partnerData.phonenumber || 'N/A'} • Registered {getTimeElapsed()}
                            </p>
                        </div>
                        <div className="d-flex gap-2">
                            {partnerData.waba_verified && (
                                <span className="badge bg-info">
                                    <MDBIcon icon="check-double" className="me-1" />
                                    WABA Verified
                                </span>
                            )}
                            {getStatusBadge(currentStatus)}
                        </div>
                    </div>

                    {/* <div className={`alert ${currentStatus === 'active' ? 'alert-success' : 'alert-info'} mb-4`}>
                        <div className="d-flex align-items-center">
                            <MDBIcon icon={currentStatus === 'active' ? 'check-circle' : 'info-circle'} className="me-2 fa-lg" />
                            <div>
                                <strong>Account Status:</strong> {getStatusMessage(currentStatus)}
                                {currentStatus === 'active' && partnerData.waba_verified && (
                                    <div className="mt-2">
                                        <MDBIcon icon="check-double" className="me-1 text-success" />
                                        <strong>Fully Verified!</strong> Your WhatsApp Business account is verified and ready to send messages.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div> */}

                    {/* WABA Details */}
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <h5 className="mb-3">
                                <MDBIcon icon="building" className="me-2" />
                                Business Account Details
                            </h5>
                            <table className="table table-sm">
                                <tbody>
                                    <tr>
                                        <th width="40%">WABA ID:</th>
                                        <td>
                                            <code>{partnerData.wabaid || 'N/A'}</code>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Business Name:</th>
                                        <td>{partnerData.waba_name || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <th>Verified Name:</th>
                                        <td>
                                            {partnerData.verified_name || 'N/A'}
                                            {partnerData.waba_verified && (
                                                <MDBIcon icon="check-circle" className="ms-2 text-success" />
                                            )}
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <th>Namespace:</th>
                                        <td>
                                            <code>{partnerData.waba_namespace || 'N/A'}</code>
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <th>Timezone:</th>
                                        <td>{partnerData.waba_timezone || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-6">
                            <h5 className="mb-3">
                                <MDBIcon icon="phone-alt" className="me-2" />
                                Phone Number Details
                            </h5>
                            <table className="table table-sm">
                                <tbody>
                                    <tr>
                                        <th width="40%">Phone Number:</th>
                                        <td>
                                            <strong>{partnerData.phonenumber || 'N/A'}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Phone Number ID:</th>
                                        <td>
                                            <code>{partnerData.phonenumberid || 'N/A'}</code>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Quality Rating:</th>
                                        <td>
                                            {getPhoneQualityBadge(partnerData.phone_quality_rating)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Embedded Signup:</th>
                                        <td>
                                            {partnerData.embedded_signup_status === 'completed' ? (
                                                <span className="text-success">
                                                    <MDBIcon icon="check-circle" className="me-1" />
                                                    Completed
                                                </span>
                                            ) : (
                                                <span className="text-warning">
                                                    <MDBIcon icon="clock" className="me-1" />
                                                    {partnerData.embedded_signup_status || 'Pending'}
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Token Information */}
                    <div className="mb-4">
                        <h5 className="mb-3">
                            <MDBIcon icon="key" className="me-2" />
                            Access Token Information
                        </h5>
                        <div className="row">
                            <div className="col-md-8">
                                <table className="table table-sm">
                                    <tbody>
                                        <tr>
                                            <th width="30%">Access Token:</th>
                                            <td>
                                                <code className="bg-light p-1 rounded">
                                                    {getTokenPreview(partnerData.waba_access_token)}
                                                </code>
                                                <button
                                                    className="btn btn-sm btn-link p-0 ms-2"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(partnerData.waba_access_token);
                                                        alert('Token copied to clipboard!');
                                                    }}
                                                    title="Copy full token"
                                                >
                                                    <MDBIcon icon="copy" />
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Expires At:</th>
                                            <td>
                                                <span className={tokenExpiry?.isExpiringSoon ? 'text-warning' : ''}>
                                                    {formatDate(partnerData.waba_access_token_expires_at)}
                                                </span>
                                                {tokenExpiry && (
                                                    <span className={`ms-2 badge ${tokenExpiry.isExpiringSoon ? 'bg-warning' : 'bg-success'}`}>
                                                        {tokenExpiry.days} days remaining
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Last Refreshed:</th>
                                            <td>{formatDate(partnerData.updatedAt)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-4">
                                <div className={`alert ${tokenExpiry?.isExpiringSoon ? 'alert-warning' : 'alert-info'} p-2 small`}>
                                    <MDBIcon icon={tokenExpiry?.isExpiringSoon ? 'exclamation-triangle' : 'info-circle'} className="me-1" />
                                    {tokenExpiry?.isExpiringSoon
                                        ? `Token expires in ${tokenExpiry.days} days. Auto-refresh will handle this.`
                                        : 'Token is valid and auto-refresh is configured.'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Embedded Signup Details */}
                    {/* <div className="mb-4">
                        <h5 className="mb-3">
                            <MDBIcon icon="plug" className="me-2" />
                            Integration Details
                        </h5>
                        <div className="row">
                            <div className="col-md-6">
                                <table className="table table-sm">
                                    <tbody>
                                        <tr>
                                            <th width="40%">Embedded Signup:</th>
                                            <td>
                                                {partnerData.embedded_signup_completed_at ? (
                                                    <span className="text-success">
                                                        <MDBIcon icon="check-circle" className="me-1" />
                                                        Completed on {formatDate(partnerData.embedded_signup_completed_at)}
                                                    </span>
                                                ) : (
                                                    'Not completed'
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Webhook Verified:</th>
                                            <td>
                                                {partnerData.webhookverified ? (
                                                    <span className="text-success">
                                                        <MDBIcon icon="check-circle" className="me-1" />
                                                        Yes
                                                    </span>
                                                ) : (
                                                    <span className="text-warning">
                                                        <MDBIcon icon="clock" className="me-1" />
                                                        Pending
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-6">
                                <table className="table table-sm">
                                    <tbody>
                                        <tr>
                                            <th width="40%">Gym ID:</th>
                                            <td>
                                                <code>{partnerData.gymid || 'N/A'}</code>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Document ID:</th>
                                            <td>
                                                <code>{partnerData._id || 'N/A'}</code>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> */}

                    {/* Actions */}
                    <div className="d-flex justify-content-between mt-4 pt-3 border-top">
                        <div>
                            {currentStatus === 'inactive' && (
                                <button
                                    onClick={onEditRegistration}
                                    className="btn btn-primary me-2"
                                >
                                    <MDBIcon icon="edit" className="me-1" />
                                    Reactivate Account
                                </button>
                            )}
                        </div>
                        <div>
                            <button
                                onClick={onEditRegistration}
                                className="btn btn-outline-primary me-2"
                            >
                                <MDBIcon icon="sync" className="me-1" />
                                Refresh Status
                            </button>
                            {/* <button
                                className="btn btn-outline-secondary"
                                onClick={() => window.location.href = '/dashboard/whatsapp/settings'}
                            >
                                <MDBIcon icon="cog" className="me-1" />
                                Settings
                            </button> */}
                        </div>
                    </div>
                </div>
                <MDBBtn
                    color="danger"
                    outline
                    className="w-100"
                    onClick={disconnectWhatsApp}
                >
                    Disconnect Account
                </MDBBtn>
            </div>

            {/* Quick Stats */}
            <div className="row">
                <div className="col-md-3 mb-3">
                    <div className="card shadow-sm">
                        <div className="card-body text-center">
                            <MDBIcon icon="check-circle" size="2x" className="text-success mb-2" />
                            <h6>Account Status</h6>
                            <p className="mb-0 fw-bold">{partnerData.status || 'N/A'}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <div className="card shadow-sm">
                        <div className="card-body text-center">
                            <MDBIcon icon="phone" size="2x" className="text-primary mb-2" />
                            <h6>Phone Number</h6>
                            <p className="mb-0 fw-bold">{partnerData.phonenumber || 'N/A'}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <div className="card shadow-sm">
                        <div className="card-body text-center">
                            <MDBIcon icon="star" size="2x" className="text-warning mb-2" />
                            <h6>Quality Rating</h6>
                            <p className="mb-0 fw-bold">{partnerData.phone_quality_rating || 'N/A'}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <div className="card shadow-sm">
                        <div className="card-body text-center">
                            <MDBIcon icon="key" size="2x" className="text-info mb-2" />
                            <h6>Token Expiry</h6>
                            <p className="mb-0 fw-bold">
                                {tokenExpiry ? `${tokenExpiry.days} days` : 'N/A'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatsAppStatusScreen;